import { useEffect } from "react";
import { useServices } from "../../contexts/ServiceContext";

export const useScrollToTop = (): void => {
    const { edgeDeploy } = useServices();
    useEffect(() => {
        if (edgeDeploy) {
            window.scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};
